import ishva from "../../../../public/projects/Tarc/projects/tarcishva.webp";
import logo from "../../../../public/projects/Tarc/logo/logo.png";



//ishva
import overviewImage_ishva from "../../../../public/projects/Tarc/images/ishva/Overview/1.webp";
import bannerDesktopImage_ishva from "../../../../public/projects/Tarc/images/ishva/Banner/1.webp";
import bannerMobileImage_ishva from "../../../../public/projects/Tarc/images/ishva/Banner/2.webp";
import siteVisitBannerImage_ishva from "../../../../public/projects/Tarc/images/ishva/SiteVisitBanner/1.webp";
import Location_ishva from "../../../../public/projects/Tarc/images/ishva/Location/L1.webp";
import Hightlights_ishva from "../../../../public/projects/Tarc/images/ishva/Highlights/1.webp";
import image1BHK_ishva from "../../../../public/projects/Tarc/images/ishva/floorplan/1.webp";
import image2BHK_ishva from "../../../../public/projects/Tarc/images/ishva/floorplan/2.webp";
import location_ishva from "../../../../public/projects/Tarc/images/ishva/Overview/l.png";
import cal_ishva from "../../../../public/projects/Tarc/images/ishva/Overview/c.png";
import newlaunch_ishva from "../../../../public/projects/Tarc/images/ishva/Overview/n.png";
import g1_ishva from "../../../../public/projects/Tarc/images/ishva/Gallery/1.webp";
import g2_ishva from "../../../../public/projects/Tarc/images/ishva/Gallery/2.webp";
import g3_ishva from "../../../../public/projects/Tarc/images/ishva/Gallery/3.webp";
import g4_ishva from "../../../../public/projects/Tarc/images/ishva/Gallery/4.webp";
import g5_ishva from "../../../../public/projects/Tarc/images/ishva/Gallery/5.webp";



export const developersTarc = {
  name: `Tarc Properties in Gurugram`,
  properties: [
    {
      name: "Tarc - Ishva",
      image: ishva,
      price: "On Request",
      location: "Sector 108",
      bed: "2 - 4 BHK",
      developer: "Sobha",
      state: "Gurugram",
      size: "....",
      url: `/tarc-ishva-sector-63a-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
  ],
};

export const Headers = {
  logo: logo,
  data: {
    experience: `1898`,
    projects: `118`,
    ongoingprojects: `18`,
  },
  about: `The Company is engaged in carrying business of construction and development of residential projects,
   commercial projects, township projects, SEZ, IT Park, malls etc. in the State of Delhi, Haryana, Uttar Pradesh and
    the National Capital Region. Additionally, the Company owns land parcels in Gurugram, Manesar and Greater Noida
     where the land holding exceed 250 acres of prime land. As a policy, the Company from time to time evaluates 
    potential of assets over the foreseeable future. 
TARC MACEO is a residential group housing project situated at Sector 91, Gurugram spread over 15.57 acres land 
comprising of premium 2, 3 & 4 Bedroom Apartments and Penthouses in 16 towers. The Company has sold over 95%
 of inventory and 400 families have already moved in their apartments. The Company as well commenced new residential
  project within the municipal limits of Delhi at Rajokri Aerocity. The Company is developing premium residential
   projects in Central West Delhi, Hauz Khas in South Delhi and Golf Course Extension Road in Gurugram besides other
    projects that are presently in planning stage at some of Company's other land parcels.


`,
};
export const projectstarc = {
  tarcishva: {
    bannerdata: {
      bannerDesktopImage:bannerDesktopImage_ishva,
      bannerMobileImage:bannerMobileImage_ishva,
      textOverlay: "",
      data: {
        title: "TARC Ishva",
        subtitle: "Sector 63A, Gurugram",
        starting_price: "₹ 6.5 Cr",
        rerano: "GGM/865/597/2024/92",
        payment_plan: "CLP",
        status: "New Launch",
      },
    },
    overview: {
      heading: "Discover Luxury Living at 4s TARC Ishva",
      description: [
       `At TARC Ishva, experience a blend of luxurious and harmonious lifestyle that celebrates the essence of your aspirations.
        Inspired by the four directions, TARC Ishva embodies the nurturing spirit of the south, the potential of new beginnings from the east,
         the realm of dreams in the west and the ambition to achieve in the north. Embrace a home inspired by India, where the openness elevates 
         wisdom, balance and peaceful living.`
      ],
      image: overviewImage_ishva,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_ishva,
          title: "₹ 6.5 Cr ",
          subtitle: "Starting price",
        },
        {
          iconClass: cal_ishva,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_ishva,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_ishva,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "2850 sq. ft.",
          price: "₹ 6.5 Cr",
        },
        {
          type: "4 BHK",
          area: "3800 sq.ft",
          price: "₹ 8.66 Cr",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
          area: "2850 sq. ft.",
          price: "₹ 6.5 Cr",
        image: image1BHK_ishva,
      },
      {
        type: "4 BHK",
          area: "3800 sq.ft",
          price: "₹ 8.66 Cr",
        image: image2BHK_ishva,
      },
    ],

    highlights: {
      images: Hightlights_ishva,
      tagline: "Highlights",
      features: [
        "EV Charging Point With Every Unit",
        "Open Bare Shell Condominium",
        "Earthquake Compliance Structure",
        "All Units Column Free Corners",
        "4 Side Open Corner Homes",
      ],
    },

    location: {
      image: Location_ishva,
      data:[
        {
          airport:{
            distance_time:"24.5 kms",
            name:"IGI Airport"
          },
          school:{
            distance_time:"2.4 Kms",
            name:"DAV School"
          },
          railwayormetro:{
            distance_time:"6.5 Kms",
            name:"Sec-55 Metro"
          },
          hospital:{
            distance_time:"2 Kms",
            name:" Marengo Hospital"
          },
          mall:{
            distance_time:"1.8 Kms",
            name:"Paras Trinity"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image:g1_ishva },
        { image:g2_ishva },
        { image:g3_ishva },
        { image:g4_ishva },
        { image:g5_ishva },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in TARC Ishva, kindly share more details.",
    },

    faq: [
      
      {
        question: "Where is TARC Ishva located?",
        answer: `The project is strategically situated in Sector 63A, Gurgaon, near Golf Course Extension Road, ensuring excellent connectivity.`,
      },
      {
        question: "What types of residences are available at TARC Ishva?",
        answer: `The project offers spacious and well-designed luxury apartments with modern layouts and high-end finishes.`,
      },
      {
        question: "What are the key amenities at TARC Ishva?",
        answer: `Amenities include a clubhouse, swimming pool, fitness center, landscaped gardens, kids’ play area, jogging track, and 24/7 security. `,
      },
      {
        question: "What is the price range of apartments in TARC Ishva?",
        answer: `Pricing varies based on unit size and configuration; prospective buyers can inquire with the developer for detailed pricing.`,
      },
      {
        question: "Is TARC Ishva RERA approved?",
        answer: `Yes, the project is RERA-registered, ensuring compliance with real estate regulations and buyer protection.`,
      },
      {
        question: "What makes TARC Ishva a standout choice for homebuyers?",
        answer: `TARC Ishva in Sector 63A, Gurgaon, stands out as a premium residential choice for homebuyers seeking luxury, exclusivity, and modern living.`,
      },
      {
        question: "How well is TARC Ishva connected to major locations in Gurgaon?",
        answer: `The project enjoys excellent connectivity to Golf Course Extension Road, Sohna Road, NH-48, and IGI Airport.`,
      },
      {
        question: "Are there reputed schools and hospitals near TARC Ishva?",
        answer: `Yes, top educational institutions like DPS International and hospitals like Medanta and Artemis are nearby.`,
      },
      {
        question: "What makes TARC Ishva a premium investment option?",
        answer: `The project offers a blend of luxury, strategic location, and the credibility of TARC, making it a valuable investment`,
      },
      {
        question: "What is the expected possession date of TARC Ishva?",
        answer: `The possession timeline is subject to construction progress; buyers should check with the developer for updates.`,
      },
    ],
    similar: {
      properties: [
        {
         
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
};
